import { Section } from "@components/NestedItemSelect/NestedItemSelect";
import {
  buildGeneralSection,
  buildPsSection,
  buildMsSection,
  buildExpenseSection,
  buildVendorQuotesSection,
  buildGovernanceSection,
  buildProductSection,
  buildResourcesSection,
  buildPricingSection,
} from "../CreateBlueprintFromProjectModal/projectSections";
import { Project } from "../CreateBlueprintFromProjectModal/types/Project";

const GENERAL_OPTIONS = [
  "customer-summary",
  "contacts",
  "terms-and-conditions",
  "teammates",
  "attachments",
  "notes",
];

const PRICING_OPTIONS = [
  "one-time-revenue-adjustments",
  "recurring-revenue-adjustments",
  "payment-credits",
];

export const buildSections = (project: Project | null): Section[] => [
  buildGeneralSection(GENERAL_OPTIONS),
  buildPsSection(project),
  buildMsSection(project),
  buildExpenseSection(project),
  buildGovernanceSection(project),
  buildVendorQuotesSection(project),
  buildProductSection(project),
  buildResourcesSection(project),
  buildPricingSection(PRICING_OPTIONS),
];
